/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
export var GeneratedFile = (function () {
    /**
     * @param {?} srcFileUrl
     * @param {?} genFileUrl
     * @param {?} source
     */
    function GeneratedFile(srcFileUrl, genFileUrl, source) {
        this.srcFileUrl = srcFileUrl;
        this.genFileUrl = genFileUrl;
        this.source = source;
    }
    return GeneratedFile;
}());
function GeneratedFile_tsickle_Closure_declarations() {
    /** @type {?} */
    GeneratedFile.prototype.srcFileUrl;
    /** @type {?} */
    GeneratedFile.prototype.genFileUrl;
    /** @type {?} */
    GeneratedFile.prototype.source;
}
//# sourceMappingURL=generated_file.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/compiler/src/aot/generated_file.js
// module id = 411
// module chunks = 3